module.exports = __webpack_public_path__ + "img/art3-img2.6cf0e866.jpeg";